// src/api/cartApi.js
import axios from "axios";

// ✅ use env when deployed, fallback to localhost for local testing
const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8080";
const API_URL = `${BASE_URL}/api/items`;

export const fetchCartItems = () => axios.get(API_URL);

export const addCartItem = (payload) => axios.post(API_URL, payload);

export const deleteCartItem = (id) => axios.delete(`${API_URL}/${id}`);

export const clearCart = () => axios.delete(`${API_URL}/clear`);

export const updateQuantity = (id, quantity) =>
  axios.put(`${API_URL}/${id}/quantity?quantity=${quantity}`);

export const fetchRecommendations = () =>
  axios.get(`${API_URL}/recommendations`);

export const clearHistory = () =>
  axios.delete(`${API_URL}/clearHistory`);
